<template>
	<div :class="['c-generations-item', { active: active === true }]">
		<header @click="toggle">
			<article>
				<span v-html="svg"> </span>
				<strong> {{ generationType }} • {{ date }} • {{ by }}</strong>
			</article>

			<section>
				<label title="Status" class="status">
					<svg
						v-if="generation.status === 'DONE'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7 13L10 16L17 8"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<svg
						v-if="generation.status === 'PROCESSING'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M12.0003 3V6M12.0003 18V21M5.63634 5.63604L7.75766 7.75736M16.2429 16.2426L18.3643 18.364M3 12.0007H6M18 12.0007H21M5.63634 18.364L7.75766 16.2426M16.2429 7.75736L18.3643 5.63604"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<svg
						v-if="generation.status === 'FAILED'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M8 8L16 16M16 8L8 16"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
						/>
					</svg>

					<span> {{ generation.status.toLowerCase() }} </span>
				</label>
			</section>

			<svg
				class="expand"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M8 10L11.4697 13.4697C11.7626 13.7626 12.2374 13.7626 12.5303 13.4697L16 10"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</header>

		<main v-if="active">
			<RenderGeneration :generation="generation"></RenderGeneration>
		</main>
	</div>
</template>

<script>
import dayjs from 'dayjs';

import generationTypes from '@swipekit/lib/generation-types';

import RenderGeneration from '@swipekit/components/utils/render-generation';

export default {
	components: {
		RenderGeneration,
	},

	data: function () {
		return {
			active: false,
		};
	},

	props: {
		generation: {},
	},

	computed: {
		svg: function () {
			let type = this.generation.type;
			let svg = '';

			for (let i = 0; i < generationTypes.length; i++) {
				let typeDetails = generationTypes[i];

				if (typeDetails.value === type) {
					svg = typeDetails.icon;
					break;
				}
			}

			return svg;
		},
		date: function () {
			let str = this.generation.createdAt;
			return dayjs(str).format(`h:MMa, D MMM`);
		},
		generationType: function () {
			let str = '';

			for (let i = 0; i < generationTypes.length; i++) {
				const typeDetails = generationTypes[i];
				if (typeDetails.value === this.generation.type) {
					str = typeDetails.key;
				}
			}

			return str;
		},
		users: function () {
			const workspace = this.$store.getters['workspaces/all'];

			return workspace.users;
		},
		by: function () {
			if (this.generation.userId) {
				const userId = this.generation.userId;
				let name = '';
				for (let i = 0; i < this.users.length; i++) {
					const user = this.users[i];
					if (user.id === userId) {
						name = `By ${user.name}`;
						if (user.lastName) {
							name = `${name} ${user.lastName}`;
						}
						break;
					}
				}
				return name;
			} else {
				return '';
			}
		},
	},

	methods: {
		toggle: function () {
			this.active = !this.active;
		},
	},
};
</script>

<style lang="scss">
.c-generations-item {
	margin-bottom: 0.5rem;
	background-color: var(--color-bg-1);
	border-radius: var(--border-radius);
	border: var(--color-bg-4) solid 1px;
	overflow: hidden;

	> header {
		position: relative;
		padding: 0.5rem;
		cursor: pointer;

		&:hover {
			background-color: var(--color-bg-2);
		}

		> svg {
			position: absolute;
			top: 1.25rem;
			right: 1rem;
		}

		article {
			display: flex;
			align-items: center;
			margin-bottom: 0.25rem;

			> span {
				display: inline-block;
				width: 24px;
				height: 24px;
				margin-right: var(--margin);
			}

			strong {
				font-weight: 500;
				font-size: var(--font-size-xs);
				line-height: 1;
			}

			> p {
				display: flex;
				align-items: center;
				margin: 0;
			}
		}
	}

	> main {
		border-top: var(--color-bg-3) solid 1px;
	}

	header > section > label {
		display: inline-flex;
		margin-right: var(--margin);
		padding: var(--margin-sm) var(--margin);
		align-items: center;
		font-size: var(--font-size-xxs);
		font-weight: 500;
		line-height: 1;
		background-color: var(--color-bg-3);
		border-radius: var(--border-radius);
		user-select: none;

		span {
			text-transform: capitalize;
		}

		svg {
			width: 20px;
			height: 20px;
			margin-right: var(--margin-sm);
		}
	}

	&.active {
		header {
			> svg {
				display: inline-block;
				&:last-of-type {
					transform: rotate(180deg);
				}
			}
		}
	}
}
</style>
